export {WCheckBox as default} from './WCheckBox';